import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyName,
    taxAgencyId,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    contract,
    contractDate,

    address,
    authDocument,
    authDocumentDate,
    checkbox1,
    checkbox2,
    district,
    email,
    email2,
    fax,
    fax2,
    field01a,
    field01b,
    field01c,
    field01d,
    organizationName,
    phone,
    phone2,
    province,
    taxId2,
    ward,
    acreage,
    address2,
    address3,
    address4,
    bankNumber,
    businessAddress,
    career,
    checkbox10,
    checkbox3,
    checkbox4,
    checkbox5,
    checkbox6,
    checkbox7,
    checkbox8,
    checkbox9,
    district2,
    province2,
    quantityUse,
    shopName,
    timeActivityFrom,
    timeActivityTo,
    ward2,
  },
} = checkout;

const validation = Yup.object().shape({
  [contract.name]: Yup.string().optional(),
  [checkbox1.name]: Yup.string().optional(),
  [checkbox2.name]: Yup.string().optional(),
  [checkbox3.name]: Yup.string().optional(),
  [checkbox4.name]: Yup.string().optional(),
  [checkbox5.name]: Yup.string().optional(),
  [checkbox6.name]: Yup.string().optional(),
  [checkbox7.name]: Yup.string().optional(),
  [checkbox8.name]: Yup.string().optional(),
  [checkbox9.name]: Yup.string().optional(),
  [checkbox10.name]: Yup.string().optional(),
  [quantityUse.name]: Yup.number().required(quantityUse.errorMsg),
  [field01a.name]: Yup.number().required(field01a.errorMsg),
  [shopName.name]: Yup.string().required(shopName.errorMsg),
  [career.name]: Yup.string().required(career.errorMsg),
  [acreage.name]: Yup.string().required(acreage.errorMsg),
  [address2.name]: Yup.string().required(address2.errorMsg),
  [address3.name]: Yup.string().required(address3.errorMsg),
  [address4.name]: Yup.string().required(address4.errorMsg),
  [bankNumber.name]: Yup.string().required(bankNumber.errorMsg),
  [businessAddress.name]: Yup.string().required(businessAddress.errorMsg),
  [organizationName.name]: Yup.string().optional(),
  [authDocument.name]: Yup.string().optional(),
  [fax.name]: Yup.string().optional(),
  [phone.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg)
    .required(phone.errorMsg),
  [fax2.name]: Yup.string().optional(),
  [phone2.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone2.invalidMsg)
    .required(phone2.errorMsg),
  [contractDate.name]: Yup.string().optional(),
  [address.name]: Yup.string().required(address.errorMsg),
  [ward.name]: Yup.string().required(ward.errorMsg),
  [province.name]: Yup.string().required(province.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [province2.name]: Yup.string().required(province2.errorMsg),
  [district2.name]: Yup.string().required(district2.errorMsg),
  [ward2.name]: Yup.string().required(ward2.errorMsg),
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [email2.name]: Yup.string().required(email2.errorMsg).email(email2.invalidMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .optional(),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId2.invalidMsg)
    .required(taxId2.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [authDocumentDate.name]: Yup.number().required(authDocumentDate.errorMsg),
  [field01b.name]: Yup.number().required(field01b.errorMsg),
  [field01c.name]: Yup.number().required(field01c.errorMsg),
  [field01d.name]: Yup.number().required(field01d.errorMsg),
  [timeActivityFrom.name]: Yup.number().required(timeActivityFrom.errorMsg),
  [timeActivityTo.name]: Yup.number().required(timeActivityTo.errorMsg),
});

export default validation;
